// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"446": "recorder","890": "profiler",}[chunkId] + "-internal-397adff6-8bb7-4d55-8a67-70735fadf870-" + {"446": "1d0f21e529c372be","890": "3a40d253b4790cbe",}[chunkId] + ".js"
}